var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg156Mute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.041,291.806l-35.844-35.844l35.844-35.844c7.808-7.807,7.807-20.465,0-28.273c-7.807-7.808-20.465-7.808-28.273,0 l-35.844,35.844l-35.844-35.844c-7.807-7.808-20.465-7.807-28.273,0c-7.808,7.807-7.808,20.465,0,28.273l35.844,35.844 l-35.844,35.844c-7.808,7.807-7.808,20.465,0,28.273c3.903,3.903,9.019,5.856,14.136,5.856s10.233-1.952,14.136-5.856 l35.844-35.844l35.844,35.844c3.903,3.903,9.019,5.856,14.136,5.856s10.233-1.952,14.136-5.856 C513.849,312.272,513.849,299.614,506.041,291.806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.166,4.873c-22.701-9.572-47.762-4.833-65.401,12.367c-0.415,0.405-0.812,0.827-1.19,1.266l-113.27,131.498H80.071 c-44.094,0-79.968,35.874-79.968,79.968v51.979c0,44.094,35.874,79.968,79.968,79.968h35.235l113.27,131.498 c0.378,0.439,0.775,0.862,1.19,1.266c11.658,11.367,26.532,17.317,41.826,17.316c7.932,0,15.978-1.601,23.743-4.875 c22.596-9.527,36.633-30.695,36.633-55.242c0-11.042-8.95-19.992-19.992-19.992c-11.042,0-19.992,8.95-19.992,19.992 c0,12.306-9.325,17.194-12.183,18.399c-2.855,1.203-12.716,4.422-21.584-3.716L139.618,328.881 c-3.797-4.409-9.328-6.944-15.147-6.944h-44.4c-22.047,0-39.984-17.937-39.984-39.984v-51.979 c0-22.047,17.937-39.984,39.984-39.984h44.4c5.819,0,11.349-2.536,15.147-6.944L258.216,45.361 c8.772-8.045,18.576-4.84,21.415-3.644c2.898,1.221,12.353,6.176,12.353,18.615v291.592c0,11.042,8.95,19.992,19.992,19.992 s19.992-8.95,19.992-19.992V60.332C331.969,35.695,317.867,14.445,295.166,4.873z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg156Mute);
export default __webpack_public_path__ + "static/media/156-mute.98cb21ac7107b03311ff0c3af6dc06f3.svg";
export { ForwardRef as ReactComponent };